// extracted by mini-css-extract-plugin
export default {"assignUserPlugin":"assignUserPlugin---lvyYR"};